import React from 'react';

import { Field } from 'react-final-form';

import { ErrorMessage } from '@qality/common-components/src/atoms/atlaskit/Form';

import { FieldErrorStyled } from './FieldError.styled';

export const FieldErrorView = ({ name }: { name: string }) => {
  const getErrorsList = (error) => {
    return error.errorsList
      ? error.errorsList.map((errorDetailsMessage, idx) => (
          <span key={idx}>{errorDetailsMessage}</span>
        ))
      : null;
  };

  return (
    <Field
      name={name}
      subscribe={{ touched: true, error: true }}
      render={({ meta: { touched, error } }) => {
        if (touched && error) {
          return (
            <ErrorMessage>
              <FieldErrorStyled>
                <span>{error?.message || error}</span>
                {getErrorsList(error)}
              </FieldErrorStyled>
            </ErrorMessage>
          );
        }
        return null;
      }}
    />
  );
};
